import { renderDynamicSection } from 'ai-rendering-library/components/text/MarkdownWithCitations/dynamicSectionRenderer';
import { CatalogItemRecommendationSectionTypename, InlineAcademyVideoResponseSectionTypename } from '../types';
import { AcademyRecommendations } from './DynamicSections/AcademyRecommendations';
import { AcademyClipCard } from './DynamicSections/AcademyClipCard';
import { jsx as _jsx } from "react/jsx-runtime";
function renderCustomSection(container) {
  const {
    responseSection
  } = container;
  switch (responseSection.__typename) {
    case CatalogItemRecommendationSectionTypename:
      return /*#__PURE__*/_jsx(AcademyRecommendations, {
        section: responseSection
      });
    case InlineAcademyVideoResponseSectionTypename:
      return /*#__PURE__*/_jsx(AcademyClipCard, {
        section: responseSection
      });
    default:
      return null;
  }
}
export function DynamicSectionRenderer({
  container
}) {
  var _renderCustomSection;
  // renders Breeze sections if the type is not one of our own
  return (_renderCustomSection = renderCustomSection(container)) !== null && _renderCustomSection !== void 0 ? _renderCustomSection : renderDynamicSection(container);
}